import { QueryKey } from "@tanstack/react-query";

export const facilityAsPublicQueryKeys = {
  all: () => ["facilityAsPublic"] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }> = {}) =>
    [...facilityAsPublicQueryKeys.all(), { filters }] as QueryKey,
};
